import { getDefaultActionStates, MESSAGE_ROLE, MessageType } from '../../Message/types/messages';

/**
 * Hardcoded OC system configuration
 */
export const OC_SYSTEM_CONFIG = {
  systemId: 'online-community',
  features: {
    reactions: true,
    reset: true,
    copyTracking: true,
  },
} as const;

/**
 * Default OC UI configuration
 * Centralized defaults for all UI options to avoid repetitive nullish coalescing
 */
export const OC_DEFAULT_UI_CONFIG = {
  title: 'AI Assistant',
  welcomeMessage: 'Welcome! How can I help you today?',
  inputPlaceholder: 'Ask me anything...',
  footerText: 'AI can make mistakes. Please verify important information.',
  showBetaBadge: false,
  askHumanButtonText: 'Ask your fellow humans',
  askHumanPromptText: 'Need opinions? AI can help you post.',
  showHorizontalSources: true,
  showVerticalSources: true,
  assistantName: 'AI Assistant',
} as const;

/**
 * Default initial message for OC chat
 */
export const getOcDefaultInitialMessage = (
  customMessage?: string,
): MessageType => ({
  role: MESSAGE_ROLE.ASSISTANT,
  message: customMessage || OC_DEFAULT_UI_CONFIG.welcomeMessage || 'Welcome! How can I help you today?',
  messageId: 'oc-initial-message',
  actionStates: getDefaultActionStates(),
  localActionStates: getDefaultActionStates(),
  hideReactions: true,
});

/**
 * Default placeholder message for loading
 */
export const OC_DEFAULT_PLACEHOLDER_MESSAGE: MessageType = {
  role: MESSAGE_ROLE.ASSISTANT,
  message: 'Connecting...',
  messageId: 'oc-placeholder',
  actionStates: getDefaultActionStates(),
  localActionStates: getDefaultActionStates(),
  hideReactions: true,
};


/**
 * Check if error is an authentication error
 * Covers both 401 Unauthorized and 403 Forbidden responses
 */
export const isAuthError = (error: Error): boolean => {
  const message = error.message.toLowerCase();
  return (
    message.includes('401') ||
    message.includes('403') ||
    message.includes('unauthorized') ||
    message.includes('forbidden') ||
    message.includes('authentication') ||
    message.includes('not authenticated')
  );
};

